<template>
  <div class="group w-full h-full transition-all ease-out duration-300" >
    <form @submit.prevent="search" id="global-search" class="h-full transition-all ease-out duration-300">
        <div class=" relative rounded-lg h-full transition-all ease-out duration-300" >
          <input type="search" name="search" id="expanded-search" minlength="1"  @focus="onExpandSearchInput"
          :autofocus="isFocused"
          v-model.trim="searchValue" @search="search()"
            class="w-full  h-full  rounded-lg hover:bg-[#ffe387d9] focus:bg-transparent placeholder:text-secondary 
            focus:ring-0 focus:border focus:border-s-[#E6E6E6] focus:border-e-[#E6E6E6]  focus:expanded-search
            block !ps-6 !pe-16 sm:text-sm border-[#E6E6E6] 
            focus:!w-[100%] lg:focus:!w-full 
            transition-all ease-out duration-300"
            :placeholder="t('pages.search.Search_place_holder')" autocomplete="off" />
          <div class=" absolute inset-y-0 end-0 flex items-center  px-5 py-3 z-10  ">
            <button type="submit" class="">
              <img src="../../assets/icons/ic-search.svg" alt="search" class="img-fluid rtl-icon"  id="search_icon"/>
            </button>
          </div>
        </div>
    </form>
  </div>

</template>

<script>
import { ref, onBeforeMount, nextTick } from "vue";
import { useRouter } from "vue-router"
import Routes from "@/common/Routes"
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n";

export default {
  name: 'expanded-search-input',
  components: { },
  props: ["isSearchCollapsed", "isFocused"],
  emits: ['onExpandSearchInput','collapseSearchInput', 'expandSearchInput'],
  setup(props , { emit }) {
    const { t } = useI18n();
    const router = useRouter()
    const store = useStore()
    const searchValue = ref(JSON.parse(JSON.stringify(sessionStorage.getItem('keyword'))) || '')

    const onExpandSearchInput = function () {
      emit('onExpandSearchInput')
    }

    onBeforeMount(() => {
      window.addEventListener('click', async function (e) {
        let isSearchClicked = document.getElementById('global-search')?.contains(e.target)
        let isShowSearchMobileBtnClicked = document.getElementById('searchBtn-mobile')?.contains(e.target)
        // Clicked outside the box
        if (isSearchClicked || isShowSearchMobileBtnClicked) {
          return
        }else {
          await nextTick()
          emit('collapseSearchInput')
        }
      });
    })
   
    return {
      t,
      searchValue,
      onExpandSearchInput,
      search() {
        if (searchValue.value != "" && searchValue.value != 'undefined') {
          sessionStorage.setItem('keyword', searchValue.value)
          store.commit('setSearchKeyword', searchValue.value)
          emit('expandSearchInput')
          if (router.currentRoute.value.fullPath.includes(Routes.SEARCH_ROUTE.name)) {
            return router.go(Routes.SEARCH_ROUTE)
          } else {
            return router.push(Routes.SEARCH_ROUTE)
          }
        } else {
          sessionStorage.removeItem('keyword')
          store.commit('setSearchKeyword', searchValue.value)
          if (router.currentRoute.value.fullPath.includes(Routes.SEARCH_ROUTE.name)) {
            return router.go(Routes.SEARCH_ROUTE)
          } 
        }
      },
    }
  },
}
</script>

<style scoped>

input {
  outline: none;
}

/* input[type=search] {

  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
  width: 0;
  padding: 0;
} */


#global-search {
  /* position: absolute; */
  /* z-index: 55; */
}
#global-search input[type=search]::-webkit-input-placeholder {
  color: black;
  font-weight: 500;
}

input[type="search" i]::-webkit-search-cancel-button {
    
    filter: invert(1) brightness(0);
    outline: none;
    cursor: pointer;
}

/* Demo 2 */

#global-search input[type=search] {
  padding-left: 0;
  color: black;
  cursor: pointer;
  border: none;
  background: transparent;
  border-left: 1px solid ;
  border-right: 1px solid ;
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
  @apply border-gray-200 w-full

  
}

#global-search .expanded-search {
  background-color: transparent !important;
}

#global-search input[type=search] {
  border: 0;
  background-color: #ffe387d9;
  background: url('../../assets/images/search-bg.png') no-repeat scroll left #ffe387d9;
}
</style>
